import axios from "axios";
import { loginreq, req,reqGet} from "../axiosFun";

// 查询广告套餐
export const getAdvertisingPackagesList = params => {
    return reqGet("get", "/app-yijiu-backstage/getAdvertisingPackagesList", params);
};

// 删除广告套餐
export const deleteAdvertisingPackages = params => {
    return reqGet("get", "/app-yijiu-backstage/deleteAdvertisingPackages", params);
};

  // 增加广告套餐
export const addAdvertisingPackages = params => {
    return req("post", "/app-yijiu-backstage/addAdvertisingPackages", params);
};

  // 修改广告套餐
  export const updateAdvertisingPackages = params => {
    return req("post", "/app-yijiu-backstage/updateAdvertisingPackages", params);
};


// WEBPACK FOOTER //
// ./src/api/manage/advertisingPackages.js